import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "../constants/api";
import {
  SG_GET_SLACK_EVENT,
  GET_SLACK_EVENT,
  SG_ADD_SLACK_EVENT,
  ADD_SLACK_EVENT,
  SG_EDIT_SLACK_EVENT,
  EDIT_SLACK_EVENT,
  SG_DELETE_SLACK_EVENT,
  DELETE_SLACK_EVENT,
  PENDING_SLACK_EVENT,
  ALL_ERRORS,
} from "../constants/actions";

function* fetchSlackEvent(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT });
    const response = yield call(api.GET_SLACK_EVENT, action.payload);
    yield put({ type: GET_SLACK_EVENT, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* addSlackEvent(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT });
    const response = yield call(api.ADD_SLACK_EVENT, action.payload);
    yield put({ type: ADD_SLACK_EVENT, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* editSlackEvent(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT });
    const response = yield call(api.EDIT_SLACK_EVENT, action.payload);
    yield put({ type: EDIT_SLACK_EVENT, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* deleteSlackEvent(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT });
    const response = yield call(api.DELETE_SLACK_EVENT, action.payload);
    yield put({ type: DELETE_SLACK_EVENT, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

export default function* slackEventSaga() {
  yield takeLatest(SG_GET_SLACK_EVENT, fetchSlackEvent);
  yield takeLatest(SG_ADD_SLACK_EVENT, addSlackEvent);
  yield takeLatest(SG_EDIT_SLACK_EVENT, editSlackEvent);
  yield takeLatest(SG_DELETE_SLACK_EVENT, deleteSlackEvent);
}